export class UserError extends Error {
  constructor(message) {
    super()

    this.message = message || 'An unknown error was found while performing the action'
  }
}